import React from 'react';
import { creativeVideoHint } from '../../../../utils/creativeAspectRatio';
import CreativeCropModal from '../../../Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/CreativeCropModal';
import CreativePreviewModal from '../../../Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/CreativePreviewModal';
import CreativeFileUpload from '../../../Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/CreativeFileUpload';
import CreativeProcessingOverlay from '../../../Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/CreativeProcessingOverlay';
import '../../../Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/AdvertiserDashboardNewCampaign.css';
import '../../../Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/CreativeEditorModal.css';

export default function CampaignCreativeFields({
    inputIds,
    creativeFileNames,
    campaignHorizontalContent,
    campaignVerticalContent,
    creativeProcessing,
    onHorizontalChange,
    onVerticalChange,
    titlePrefix = '',
}) {
    const prefix = titlePrefix ? `${titlePrefix} ` : '';

    return (
        <>
            {creativeProcessing && (
                <CreativeProcessingOverlay message={creativeProcessing.message} />
            )}

            <div className='newCampaignInputTwoContainer'>
                <span className='newCampaignInputTitle'>{prefix}Horizontal content (16:9 landscape)</span>
                <span className='newCampaignInputHint'>Images: any aspect ratio — we will help you crop. Large images are resized automatically. {creativeVideoHint('horizontal')}</span>
                <CreativeFileUpload
                    inputId={inputIds.horizontal}
                    accept="image/*,video/mp4,video/x-m4v,video/*"
                    fileName={creativeFileNames.horizontal}
                    isReady={Boolean(campaignHorizontalContent)}
                    disabled={Boolean(creativeProcessing)}
                    onChange={onHorizontalChange}
                />
            </div>

            <div className='newCampaignInputTwoContainer'>
                <span className='newCampaignInputTitle'>{prefix}Vertical content (9:16 portrait)</span>
                <span className='newCampaignInputHint'>Images: any aspect ratio — we will help you crop. Large images are resized automatically. {creativeVideoHint('vertical')}</span>
                <CreativeFileUpload
                    inputId={inputIds.vertical}
                    accept="image/*,video/mp4,video/x-m4v,video/*"
                    fileName={creativeFileNames.vertical}
                    isReady={Boolean(campaignVerticalContent)}
                    disabled={Boolean(creativeProcessing)}
                    onChange={onVerticalChange}
                />
            </div>
        </>
    );
}

export function CampaignCreativeModals({
    creativeEditor,
    cropExporting,
    onCancel,
    onCropNext,
    onPreviewNext,
}) {
    return (
        <>
            {creativeEditor?.step === 'crop' && (
                <CreativeCropModal
                    slot={creativeEditor.slot}
                    imageSrc={creativeEditor.imageSrc}
                    onCancel={onCancel}
                    onNext={onCropNext}
                    exporting={cropExporting}
                />
            )}
            {creativeEditor?.step === 'preview' && (
                <CreativePreviewModal
                    slot={creativeEditor.slot}
                    previewUrl={creativeEditor.previewUrl}
                    isVideo={creativeEditor.isVideo}
                    videoMimeType={creativeEditor.videoMimeType}
                    onCancel={onCancel}
                    onNext={onPreviewNext}
                />
            )}
        </>
    );
}
